import React, { useEffect, useState, useRef } from 'react';
import { PipelineStage } from '../types';
import { ChevronDownIcon, CheckIcon, XIcon } from 'lucide-react';
interface PipelineStageFilterProps {
  stages: PipelineStage[];
  selectedStages: PipelineStage[];
  onSelectionChange: (stages: PipelineStage[]) => void;
}
export const PipelineStageFilter: React.FC<PipelineStageFilterProps> = ({
  stages,
  selectedStages,
  onSelectionChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const toggleStage = (stage: PipelineStage) => {
    if (selectedStages.includes(stage)) {
      onSelectionChange(selectedStages.filter(s => s !== stage));
    } else {
      onSelectionChange([...selectedStages, stage]);
    }
  };
  const clearAll = () => {
    onSelectionChange([]);
  };
  const selectAll = () => {
    onSelectionChange([...stages]);
  };
  const allSelected = selectedStages.length === 0;
  const someSelected = selectedStages.length > 0;
  const buttonLabel = allSelected ? 'All Stages' : selectedStages.length === 1 ? selectedStages[0] : `${selectedStages.length} Stages`;
  return <div className="relative" ref={dropdownRef} data-id="element-130">
      <button onClick={() => setIsOpen(!isOpen)} className={`flex items-center gap-2 px-3 py-2 border rounded-lg text-sm font-medium transition-all ${someSelected ? 'bg-blue-50 dark:bg-blue-900/30 border-blue-200 dark:border-blue-800 text-blue-700 dark:text-blue-400' : 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:border-gray-400 dark:hover:border-gray-600'}`} data-id="element-131">
        <span data-id="element-132">{buttonLabel}</span>
        {someSelected && <button onClick={e => {
        e.stopPropagation();
        clearAll();
      }} className="flex items-center justify-center w-4 h-4 rounded-full bg-blue-200 dark:bg-blue-800 hover:bg-blue-300 dark:hover:bg-blue-700 transition-colors" data-id="element-133">
            <XIcon className="w-3 h-3 text-blue-700 dark:text-blue-300" data-id="element-134" />
          </button>}
        <ChevronDownIcon className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-135" />
      </button>

      {isOpen && <div className="absolute top-full left-0 mt-1 w-56 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50 py-1" data-id="element-136">
          <button onClick={selectAll} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" data-id="element-137">
            <div className={`w-4 h-4 rounded border flex items-center justify-center ${allSelected ? 'bg-gray-900 dark:bg-blue-600 border-gray-900 dark:border-blue-600' : 'border-gray-300 dark:border-gray-600'}`} data-id="element-138">
              {allSelected && <CheckIcon className="w-3 h-3 text-white" data-id="element-139" />}
            </div>
            All Stages
          </button>

          <div className="border-t border-gray-100 dark:border-gray-700 my-1" data-id="element-140" />

          {stages.map(stage => {
        const isSelected = selectedStages.includes(stage);
        return <button key={stage} onClick={() => toggleStage(stage)} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" data-id="element-141">
                <div className={`w-4 h-4 rounded border flex items-center justify-center ${isSelected ? 'bg-blue-600 border-blue-600' : 'border-gray-300 dark:border-gray-600'}`} data-id="element-142">
                  {isSelected && <CheckIcon className="w-3 h-3 text-white" data-id="element-143" />}
                </div>
                {stage}
              </button>;
      })}
        </div>}
    </div>;
};